enum BuildingFoundationType {
	BELOW_GRADE = 'BelowGrade',
	SLAB_ON_GRADE = 'SlabOnGrade',
	CRAWL_SPACE = 'CrawlSpace',
	ELEVATED_FLOOR = 'ElevatedFloor',
}

export default BuildingFoundationType;